import React, { useState } from 'react'
import { Card, CardHeader, CardTitle, CardBody } from '../../../Card'
import { Badge } from '../../../../atoms/Badge'
import type { LandZonesProps } from '../../LandSection.types'
import { ZoneItem } from './ZoneItem'
import { ZonesList, ZoneCount } from './LandZones.styles'

export const LandZones: React.FC<LandZonesProps> = ({
  zones,
  defaultExpanded = 0,
  onZoneToggle,
  className,
  t,
}) => {
  const [expandedZones, setExpandedZones] = useState<Set<number>>(
    new Set([defaultExpanded])
  )

  const handleToggle = (index: number) => {
    setExpandedZones((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(index)) {
        newSet.delete(index)
      } else {
        newSet.add(index)
      }
      return newSet
    })

    onZoneToggle?.(index)
  }

  if (!zones || zones.length === 0) {
    return null
  }

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>
          {t('zones.title')}
          <ZoneCount>
            <Badge variant="default">{zones.length}</Badge>
          </ZoneCount>
        </CardTitle>
      </CardHeader>
      <CardBody>
        <ZonesList>
          {zones.map((zone, index) => (
            <ZoneItem
              key={`zone-${index}`}
              zone={zone}
              index={index}
              isExpanded={expandedZones.has(index)}
              onToggle={() => handleToggle(index)}
              t={t}
            />
          ))}
        </ZonesList>
      </CardBody>
    </Card>
  )
}
